import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { CrashScreen } from './components/CrashScreen.js';
import './app.css';
import { AppDataProvider } from './data/AppDataProvider.js';
import { I18nProvider } from './providers/I18nProvider.js';
import { ThemeProvider } from './providers/ThemeProvider.js';

const container = document.getElementById('root');
if (!container) throw new Error('#root missing');

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <I18nProvider>
        {/* Inside I18n so the failure can be explained in the reader's own
            language, and outside AppDataProvider so a throw while folding the
            log is caught too — that is exactly the case where someone needs to
            be told their record is still there. */}
        <CrashScreen>
          <AppDataProvider>
            <App />
          </AppDataProvider>
        </CrashScreen>
      </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
);
